<template>
  <teleport to="#section-reports">
    <button
        class="not-print float-left"
        @click="exportExcel($event.currentTarget)"
      >
        Экспорт&nbsp;в&nbsp;EXCEL
    </button>
    <div
      class="temlate-report"
      id="vehicle-efficiency-template-content"
    >
      
      <template v-if="props.isTitle">
        <h6 class="text-center font-weight-bold template-h">
          {{ props.reportTitle }}
        </h6>

        <!-- <p
          class="text-center excel-bottom-indent excel-auto-height"
        >
          Отчет составлен по ТС {{ vehiclesStr }}
        </p> -->

        <p class="text-center excel-bottom-indent">
          {{ titleInterval }}
        </p>
      </template>

      <hr class="not-print margin-none" />

      <skills-man-report
        :is-title="false"
        :data="props.data"
        :show-driver-columns="true"
        :is-template-wrapper="false"
      />
    </div>
    <div class="not-print margin-bottom"></div>
  </teleport>
</template>

<script setup>
import { watch, computed, onBeforeMount } from '@vue/runtime-core';
import SkillsManReport from '../SkillsMan/SkillsManReport.vue';

const props = defineProps({
  isTitle: {
    type: Boolean,
    default: true,
  },
  data: {
    type: Object,
    required: true,
  },
  reportTitle: {
    type: String,
    default: 'Оценка эффективности эксплуатации по парку ТС',
  },
  excelName: {
    type: String,
    default: 'Оценка эффективности эксплуатации по парку ТС',
  },
});

const emit = defineEmits(['outputTitleHtml']);

const exportExcel = (btn) => {
  window.html_to_excel_helper?.export?.(
    btn,
    'vehicle-efficiency-template-content',
    props.excelName,
    'portrait',
  );
};

onBeforeMount(() => {
  const sectionReports = document.getElementById('section-reports');
  if (sectionReports) {
    sectionReports.innerHTML = '';
  }
});

const titleInterval = computed(() => {
  const first = props.data.objects[0];
  return first && first['view'] ? first['view']['t_interval'] : '';
});

const objects = computed(() => props.data.objects || []);

const vehiclesStr = computed(() =>
  objects.value.map(vehicleLabel).filter(Boolean).join(', '),
);

watch(
  () => props.isTitle,
  (cond) => {
    if (!cond) {
      emit(
        'outputTitleHtml',
        `<h6 class="text-center font-weight-bold">
        ${props.reportTitle}
      </h6>

      <p class="text-center excel-bottom-indent">
      Отчет составлен по ТС ${vehiclesStr.value}
      </p>

      <p class="text-center excel-bottom-indent">
      ${titleInterval.value}
      </p>
      `,
      );
    }
  },
  { immediate: true },
);

const vehicleLabel = (obj) => {
  const model = obj['avtoModel'] || '';
  const name = obj['name'] || '';
  if (model || name) return `${model} ${name}`.trim();
  return '';
};
</script>
